var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprytechies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 132",
    xmlSpace: "preserve",
    style: {
      background: "0 0"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.7,
    cy: 66.76,
    r: 60.8,
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#028905",
    d: "M105.622 118.679c-27.566 17.5-60.352 10.095-77.926-9.233 9.733-1.501 19.167-2.621 28.458-4.46 17.504-3.466 34.946-7.254 52.363-11.136 3.338-.744 6.574-2.285 9.63-3.893 9.6-5.053 10.037-12.123.384-17.236-8.252-4.37-17.274-7.327-26.054-10.647-8.463-3.2-17.205-5.706-25.525-9.222-4.294-1.815-9.428-4.57-9.254-10.028.174-5.5 5.563-7.99 9.945-9.356C81.972 29 96.5 25.155 111.045 21.434c1.47-.376 4.01 1.31 5.31 2.722 9.445 10.256 15.44 22.137 16.735 36.24 2.27 24.7-7.138 43.848-27.468 58.283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8202",
    d: "M65 23.991c-11.37 2.664-22.367 5.08-33.206 8.07-4.206 1.159-9.266 2.89-9.379 8.32-.107 5.158 4.667 7.249 8.66 8.523 13.383 4.274 27.075 7.613 40.355 12.167 6.59 2.26 12.972 5.785 18.655 9.847 5.29 3.781 5.356 8.85-.063 12.337-7.292 4.693-15.213 8.88-23.427 11.559-12.713 4.146-25.872 6.96-38.924 9.987-1.715.398-4.764-.682-5.763-2.092C-3.44 66.936 15.23 16.203 58.83 6.958c16.267-3.45 31.574-.963 45.788 7.79.696.429 1.389.873 2.024 1.383.2.16.206.56.412 1.192C93.137 19.546 79.287 21.759 65 23.99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprytechies);
export default __webpack_public_path__ + "static/media/sprytechies.ec9ba95338900d2be1808bd146b0e5a5.svg";
export { ForwardRef as ReactComponent };